module.exports = __webpack_public_path__ + "static/media/ADDVA_GUIDE.4e67c474.svg";